import React, { FC, memo } from "react";
import { NavLink } from "react-router";
import { Box, Button, IconButton } from "@mui/material";
import { observer } from "mobx-react";

import { useAppStore } from "../../../hooks/useAppStore";
import { NewChatIcon } from "../../icons";
import { useChatStore } from "../../../hooks/useChatStore";
import { useChatCategoryStore } from "../../../hooks/useChatCategoryStore";

const SidebarFooterContent: FC = observer(function SidebarFooterContent() {
  const {
    isHomeV2Enabled,
    isCollapsed,
    isSidebarMobile,
    setContractToPreview,
    setPolicyToPreview,
  } = useAppStore();
  const { clearChatCategoryStore, setIsPoliciesDocumentsDrawerOpen } =
    useChatCategoryStore();
  const chatStore = useChatStore();

  const isHidden = isCollapsed || isSidebarMobile;
  const newChatPath = isHomeV2Enabled ? "/new-chat" : "/";

  const resetStore = () => {
    clearChatCategoryStore(true);
    setContractToPreview(null);
    setPolicyToPreview(null);
    setIsPoliciesDocumentsDrawerOpen(false);
    chatStore.reset();
  };

  return (
    <Box
      sx={{
        display: "flex",
        paddingTop: 2,
        paddingBottom: 2,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        width: "100%",
        borderTop: !isHidden ? "1px solid rgba(0, 0, 0, 0.12)" : "none",
        flexShrink: 0,
      }}
    >
      <NavLink
        to={newChatPath}
        style={{
          ...(isHidden ? {} : { width: "100%", maxWidth: "90%" }),
          textDecoration: "none",
        }}
      >
        {isHidden ? (
          <IconButton
            sx={{ backgroundColor: "primary.main" }}
            aria-label="New chat"
            onClick={resetStore}
          >
            <NewChatIcon />
          </IconButton>
        ) : (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            startIcon={<NewChatIcon />}
            onClick={resetStore}
          >
            {isHidden ? "" : "New Chat"}
          </Button>
        )}
      </NavLink>
    </Box>
  );
});

export default memo(SidebarFooterContent);
